<template>
    <div class="privacy-statement">
        <h1>Privacy verklaring</h1>
        <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus magna lorem, a dignissim elit posuere
            vulputate. Suspendisse accumsan, odio et iaculis laoreet, nunc ligula pharetra orci, quis pretium tellus
            odio in ipsum. Maecenas vel condimentum leo, et facilisis elit. Class aptent taciti sociosqu ad litora
            torquent per conubia nostra, per inceptos himenaeos. Morbi imperdiet vel dui in gravida. Integer viverra ac
            sapien eu imperdiet. Donec tincidunt et tellus nec vehicula.
        </p>
        <p>
            Nulla non erat dui. Sed sit amet neque convallis, dictum ipsum sit amet, molestie magna. Fusce luctus leo a
            magna dapibus, vel consequat tortor dapibus. Maecenas interdum nulla vitae interdum pellentesque. Vestibulum
            a magna et felis eleifend congue. Mauris dictum rhoncus dolor nec vulputate. Integer varius dolor nec nibh
            semper tempus nec at odio. Vestibulum quis augue non ante lobortis convallis. Ut laoreet, elit vel rutrum
            rutrum, neque libero fringilla sapien, sit amet interdum neque orci eget dolor.
        </p>
        <p>
            Proin risus justo, tristique quis malesuada id, lacinia nec lacus. Suspendisse quam arcu, auctor at aliquet
            sit amet, malesuada placerat quam. Proin tempus leo ut libero imperdiet tempor. Aliquam dui ipsum, elementum
            vitae erat eu, hendrerit eleifend eros. Integer sit amet ultrices orci, in vulputate tellus. Nunc placerat
            diam ac ultricies blandit. Quisque nulla orci, hendrerit facilisis dapibus non, interdum gravida tortor.
            Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse
            potenti. Phasellus rhoncus augue purus, at vulputate dui suscipit eget. Pellentesque non feugiat nisl.
        </p>
        <p>
            Vivamus ullamcorper, tellus tincidunt finibus tempor, augue nunc egestas justo, et pulvinar risus nunc ac
            erat. Praesent quis scelerisque leo, eget euismod neque. Aliquam at bibendum elit. Vivamus in tellus lacinia
            nunc sollicitudin consectetur. Nunc bibendum vestibulum egestas. Quisque vulputate tellus libero, et viverra
            nisl bibendum eu. Fusce eu dignissim lectus, nec elementum odio.
        </p>
        <p>
            Aliquam erat volutpat. Curabitur sed enim a eros lobortis lobortis non id augue. Nam sit amet augue sed
            felis pellentesque suscipit. Nunc dictum nulla id consequat vulputate. Aenean eget sagittis massa, eu
            fermentum odio. Nullam a neque eu felis mattis faucibus. Phasellus eu lorem id est luctus molestie nec vitae
            odio. Vivamus commodo nibh purus, vel imperdiet lacus auctor nec. Fusce ullamcorper sapien velit, et auctor
            nisi elementum in.
        </p>
    </div>
</template>

<script>
export default {
    name: 'privacy-statement',
};
</script>
